import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Videos/Video'
import { mediaPlatformVideosRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Videos'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Videos/Video'

export const mediaPlatformVideoRoute = createRoute({
  getParentRoute: () => mediaPlatformVideosRoute,
  path: DynamicRouteParameterWPrefix.VIDEO_ID,
  loader: () => ({
    crumb: t('entity:publishing.video', { count: 1 }),
  }),
})

export const mediaPlatformVideoLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformVideoRoute,
  id: 'mediaPlatformVideoLayout',
  component: Structure,
})

export const mediaPlatformVideoRawRoute = createRoute({
  getParentRoute: () => mediaPlatformVideoLayoutRoute,
  path: '/',
  component: Overview,
})
